// extracted by mini-css-extract-plugin
export default {"priceStrikethrough":"FlightDetailsAncillaryItem-module__priceStrikethrough___R5845","badges":"FlightDetailsAncillaryItem-module__badges___EHzxZ"};